/* eslint-disable @typescript-eslint/no-explicit-any */

import React from "react";

import { useStrings } from "../../localization/localizationHelpers";
import { ContentBoxIcon } from "../ContentBox";
import { InfoBoxBase } from "../InfoBoxBase";

export const InfoBoxApplicationRejected = () => {
  const [infoBoxApplicationRejectedMessage, infoBoxApplicationRejectedSubtitle] = useStrings(
    "infoBoxApplicationRejectedMessage",
    "infoBoxApplicationRejectedSubtitle"
  );

  return (
    <InfoBoxBase
      title={infoBoxApplicationRejectedMessage}
      icon={ContentBoxIcon.Lock}
      rightSideText={infoBoxApplicationRejectedSubtitle}
    />
  );
};
